export default "__VITE_ASSET__CaVSY8MA__"